module.exports = __webpack_public_path__ + "static/img/return-dialog.23a4e45b.png";